import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { User } from '~/common/api/zeiterfassungServerApi/UsersApi';

export const formatName = (
  employee?: Employee | null,
  t?: <T>(text: T, params?: Parameters<never>) => string | T | undefined,
): string => {
  if (!employee && t) {
    return t('dashboard.newpic.employee.unknown')!;
  }
  if (!employee?.user?.last_name && !employee?.user?.first_name) {
    return `${employee?.user?.first_name}` || 'Unknown.';
  }
  return `${employee?.user?.last_name}, ${employee.user?.first_name}`;
};

export function formatUsername(user?: User) {
  if (!user) return 'Unkown';
  if (!user.first_name) return user.username;
  return `${user.last_name}, ${user.first_name}`;
}
